export default __webpack_public_path__ + "static/media/darkAdd.1c7c915e.svg";